/* UI 124: one quantity policy for theme add/change paths. Shopify remains
   authoritative for availability, prices and selling-plan payment amounts. */
(() => {
  let queue = Promise.resolve();
  const positiveLimit = value => {
    const n = Number(value);
    return Number.isSafeInteger(n) && n > 0 ? n : Infinity;
  };
  const productQuantity = (cart, productId, variantId, exceptKey) => cart.items.reduce((sum, item) => {
    const matches = productId ? String(item.product_id) === String(productId) : String(item.variant_id || item.id) === String(variantId);
    return sum + (matches && item.key !== exceptKey ? Number(item.quantity) : 0);
  }, 0);
  const run = task => {
    const execute = () => navigator.locks?.request ? navigator.locks.request('bw-cart-mutation', task) : task();
    const result = queue.then(execute, execute);
    queue = result.catch(() => {});
    return result;
  };
  const read = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Cart read failed');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart;
  };
  const warn = () => {
    const popup = document.querySelector('[quantity-message-popup]');
    if (popup) {
      popup.style.display = 'block';
      popup.setAttribute('role', 'alertdialog');
      popup.querySelector('button')?.focus({ preventScroll: true });
    }
  };
  const inputLimit = input => {
    const productForm = input.closest('product-info')?.querySelector('product-form[purchase-limit]');
    return Math.min(positiveLimit(input.dataset.bwPurchaseLimit), positiveLimit(productForm?.getAttribute('purchase-limit')));
  };
  // Keep the table, product images and drawer actions mounted on quantity-only
  // changes. Server-rendered price/quantity cells and payment summary still update.
  const render = (target, html) => {
    const next = document.createElement('div');
    next.innerHTML = html;
    const oldRows = [...target.querySelectorAll('.cart-item[data-bw-line-key]')];
    const newRows = [...next.querySelectorAll('.cart-item[data-bw-line-key]')];
    const sameLines = oldRows.length > 0 && oldRows.length === newRows.length && oldRows.every((row, i) => row.dataset.bwLineKey === newRows[i].dataset.bwLineKey);
    if (!sameLines) { target.innerHTML = html; return; }
    oldRows.forEach((row, i) => {
      [...row.children].forEach((cell, j) => {
        if (!cell.classList.contains('cart-item__media') && newRows[i].children[j]) cell.innerHTML = newRows[i].children[j].innerHTML;
      });
    });
    const sourceCount = next.querySelector('[data-bw-cart-count-source]');
    const currentCount = target.querySelector('[data-bw-cart-count-source]');
    if (sourceCount && currentCount) currentCount.dataset.bwCartCountSource = sourceCount.dataset.bwCartCountSource;
    const currentFooter = target.querySelector('.cart-drawer__footer');
    const nextFooter = next.querySelector('.cart-drawer__footer');
    if (currentFooter && nextFooter) {
      // Preserve the live checkout chooser/button and its event listeners.
      const actions = currentFooter.querySelector('.cart__ctas');
      const newActions = nextFooter.querySelector('.cart__ctas');
      if (actions && newActions) newActions.replaceWith(actions);
      currentFooter.replaceChildren(...nextFooter.childNodes);
    }
  };
  window.bwCartGuard = { positiveLimit, productQuantity, run, read, warn, inputLimit, render };
})();
